import src from "IMAGE";
export default { src, width: 140, height: 33, blurWidth: 0, blurHeight: 0};
